export const FOOTER_LINKS = {
	PRIVACY_POLICY: 'https://healthstaff.org/privacypolicy/',
	COOKIE_POLICY: 'https://healthstaff.org/cookie-policy/',
	ABOUT: 'https://healthstaff.org/',
    FACEBOOK: 'https://www.facebook.com/worldwidehealthstaffsolutions/',
    LINKEDIN: 'https://www.linkedin.com/company/worldwidehealthstaff/',
}
